/**
 * Analytics tracking middleware function
 * Sending events to GTM
 *
 * @param eventAction
 * @param eventCategory
 * @param eventLabel
 * @param eventValue
 * @param additionalData Used for Interaction Studio via GTM. All data passed to this field will be merged with initial event object
 *
 */
function event(eventAction, eventCategory, eventLabel, eventValue = null, additionalData = null) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'analyticsEvent',
		'eventAction': eventAction,
		'eventCategory': eventCategory,
		'eventLabel': eventLabel,
		'eventValue': eventValue,
		'additionalData': additionalData,
	});
}
function event4(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'analyticsEvent4',
        'eventName': eventName,
        'eventParams': params,
    });
}

export {event, event4};
